import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./confWarehouse/confWarehouse.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Snackbar from "../utils/snackbar/Snackbar";
import DownloadExportExcel from "./DownloadExportExcel";
import { CircularProgress, Tooltip } from "@material-ui/core";
import Table from "../../views/Table/Table.js";
import axios from "axios";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    background: "transparent",
    borderColor: "transparent",
  },
}));

const Export = (props) => {
  const [selectedStartDate, setDate] = React.useState(moment());
  const [inputValue, setInputValue] = React.useState(
    moment().format("YYYY-MM-DD")
  );
  const [selectedEndDate, setEndDate] = React.useState(moment());
  const [inputEndValue, setInputEndValue] = React.useState(
    moment().format("YYYY-MM-DD")
  );
  const [text, setText] = React.useState("");
  const [data, setData] = React.useState(false);
  const [partDetails, setPartDetails] = React.useState(false);
  const [part1Details, setPart1Details] = React.useState(false);
  const [noData, setNodata] = React.useState(" ");
  const [count, setCount] = React.useState(0);
  const [count2, setCount2] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  React.useEffect(() => {
    if (data == false) {
      setNodata(false);
    }
  });

  // React.useEffect(() => {
  //   const check = () => {
  //     if (data && data.data.inward !== null) {
  //       data.data.inward.forEach((val, index) => {
  //         {
  //           parts.push([
  //             index + 1,
  //             val.purchaseDate,
  //             val.productCategory,
  //             val.productName,
  //             val.supplierName,
  //             val.inwardQuantity,
  //           ]);
  //         }
  //         setPartDetails(parts);
  //         setNodata(false);
  //         setCount(parts.length);
  //       });
  //     }
  //     if (parts.length === 0) {
  //       setPartDetails(false);
  //       setNodata("Data not found");
  //     }
  //   };
  //   check();
  //   console.log("hey", parts);
  //   const check1 = () => {
  //     if (data && data.data.outward !== null) {
  //       data.data.outward.forEach((val, ind) => {
  //         {
  //           parts1.push([
  //             ind + 1,
  //             val.billingDate,
  //             val.productCategory,
  //             val.productName,
  //             val.dealerName,
  //             val.outwardQuantity,
  //           ]);
  //         }
  //         setPart1Details(parts1);
  //         setNodata(false);
  //         setCount2(parts1.length);
  //       });
  //     }
  //     if (parts1.length === 0) {
  //       setPart1Details(false);
  //       setNodata("Data not found");
  //     }
  //   };
  //   check1();
  // }, [data]);

  let parts = [];
  let parts1 = [];

  const onDateChange = (date, value) => {
    setDate(date);
    setInputValue(value);
  };
  const onDateEndChange = (date, value) => {
    setEndDate(date);
    setInputEndValue(value);
  };
  const dateFormatter = (str) => {
    return str;
  };
  const fetchOrder = () => {
    axios({
      method: "post",
      url: "/generateInvExcelReport",
      data: {
        from: inputValue,
        to: inputEndValue,
      },
    })
      .then((res) => {
        console.log('request submitted');
        console.log(res);
        if(res.data && res.data.success) {
          // setData(res.data);
          setAlert(res.data.msg);
        } else {
          setAlert('Something Went Wrong');
        }
        setNodata(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setNodata(false);
        setLoading(false);
      });
  };

  const onSubmit = () => {
    setLoading(true);
    fetchOrder();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth={"lg"}
      scroll={"paper"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>Generate Inventory Report</h1>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {/* {partDetails && part1Details && data.data && !noData && (
                <DownloadExportExcel parts={data.data} />
              )} */}

              <IconButton onClick={props.onClose}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </div>
          <div className={styles.row}>
            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
              <KeyboardDatePicker
                autoOk={true}
                className={styles.textField}
                label="Start Date"
                inputVariant="outlined"
                value={selectedStartDate}
                format="YYYY-MM-DD"
                onChange={onDateChange}
                rifmFormatter={dateFormatter}
                minDate={moment().subtract(6, "months")}
                maxDate={moment()}
                InputLabelProps={{ shrink: true, required: true }}
                inputValue={inputValue}
              />
            </MuiPickersUtilsProvider>
            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
              <KeyboardDatePicker
                autoOk={true}
                className={styles.textField}
                label="End Date"
                inputVariant="outlined"
                value={selectedEndDate}
                format="YYYY-MM-DD"
                onChange={onDateEndChange}
                rifmFormatter={dateFormatter}
                minDate={inputValue}
                maxDate={moment()}
                InputLabelProps={{ shrink: true, required: true }}
                inputValue={inputEndValue}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div className={styles.footer}>
            {loading ? (
              <Button variant="contained" color="secondary">
                Loading....
              </Button>
            ) : (
              <Button variant="contained" color="secondary" onClick={onSubmit}>
                Submit
              </Button>
            )}
          </div>
          <Snackbar open={alert} handleClose={() => setAlert(false)} />
          {/* {<h4>{noData}</h4>}
          {partDetails && (
            <div className={styles.content}>
              <h2>Inwards Parts Data</h2>

              <h2 style={{ color: "grey" }}>Total:{count}</h2>

              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "SI No",
                  "Purchase Date",
                  "Item Category",
                  "Product Name",
                  "Supplier Name",
                  "Inward Quantity",
                ]}
                tableData={partDetails}
              />
            </div>
          )}

          {part1Details && "OUTWARD DATA" && (
            <div style={{ marginTop: "30px" }}>
              <h2>Outwards Parts Data</h2>

              <h2 style={{ color: "grey" }}>Total:{count2}</h2>
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "SI No",
                  "Billing Date",
                  "Item Category",
                  "Product Name",
                  "Dealer Name",
                  "Outward Quantity",
                ]}
                tableData={part1Details}
              />
            </div>
          )} */}
        </div>
      </div>
    </Dialog>
  );
};
export default Export;
